<!-- @format -->

@if (customizerURL !== undefined) {
	<iframe
		class="customizer-iframe"
		[src]="customizerURL"
		title="{{ product?.name }} customizer"
		loading="lazy"></iframe>
}
